import { IRange, INordicStats, IResortDates } from 'api/resort/types';

export const hasRangeData = (range?: IRange) => !!(range && range.open && range.total);

export const hasNordicStatsData = (nordicStats?: INordicStats | undefined) => !!(
  nordicStats?.trackset
  || nordicStats?.skategroomed
  || nordicStats?.open
);

export const hasAnyImportantDates = (dates?: IResortDates | undefined) => !!(
  dates?.averageSnowfall
  || dates?.daysOpenLastYear
  || dates?.projectedClosing
  || dates?.projectedDaysOpen
  || dates?.projectedOpening
  || dates?.yearsOpen
);

export const isEmpty = (d: unknown | null | undefined) => d === null || typeof d === 'undefined';
